export default __webpack_public_path__ + "static/media/020-study.1eab2eef.svg";